import { render, staticRenderFns } from "./EventDetailView.vue?vue&type=template&id=0901074b&scoped=true"
import script from "./EventDetailView.vue?vue&type=script&lang=js"
export * from "./EventDetailView.vue?vue&type=script&lang=js"
import style0 from "./EventDetailView.vue?vue&type=style&index=0&id=0901074b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0901074b",
  null
  
)

export default component.exports